import { FiltersToApplyOnInbox } from "containers/admin/inbox/inbox.types";
import { QuickFilterTypes } from "types/inbox";

export const INBOX_FILTER_IDS = {
  quickFilters: "quickFilters",
  clientReviewStatus: "clientReviewStatus",
  creativeType: "creativeType",
  contentTypes: "contentTypes",
  comments: "comments",
  programType: "programType",
  populationType: "populationType",
  classes: "classes",
} as const;

export const DEFAULT_INBOX_FILTERS_TO_APPLY: FiltersToApplyOnInbox = {
  [INBOX_FILTER_IDS.quickFilters]: [],
  [INBOX_FILTER_IDS.clientReviewStatus]: [],
  [INBOX_FILTER_IDS.creativeType]: [],
  [INBOX_FILTER_IDS.contentTypes]: [],
  [INBOX_FILTER_IDS.comments]: [],
  [INBOX_FILTER_IDS.programType]: [],
  [INBOX_FILTER_IDS.populationType]: [],
  [INBOX_FILTER_IDS.classes]: [],
};

export const INBOX_FILTER_ID_TO_TITLE: Record<string, string> = {
  [INBOX_FILTER_IDS.clientReviewStatus]: "Client review status",
  [INBOX_FILTER_IDS.creativeType]: "Channel",
  [INBOX_FILTER_IDS.contentTypes]: "Content type",
  [INBOX_FILTER_IDS.comments]: "Comments",
  [INBOX_FILTER_IDS.programType]: "Program type",
  [INBOX_FILTER_IDS.populationType]: "Population type",
  [INBOX_FILTER_IDS.classes]: "Class",
};

export const INBOX_FILTER_VALUE_TO_LABEL: Record<string, string> = {
  [QuickFilterTypes.hasOpenActionItems]: "Has open action items",
};
